'use strict';
exports.__esModule = true;
exports.default = {
  deng_lu: 'login',
  unit_cup: 'unit:cup',
  bu_ran: 'otherwise',
  shi_xian_chui_zhi_ju_zhong: 'Achieve vertical centering',
  zhang_dan_jin_e: 'Bill amount',
  qing_shu_ru_tui_kuan_zheng_shu: 'Please enter a refund certificate',
  dao_chu_shi_jian_qu_jian: 'Export time interval',
  qing_she_ding_she_bei_suo_zai_wei_zhi: 'Please set the location of the device',
  ji_fei_she_bei_zong_shu: 'Total billing equipment',
  yi_xuan_she_bei: 'Selected equipment',
  ding_dan_shan_chu: 'Delete order',
  qing_shu_ru_shou_quan_mi_yao: 'Please enter the authorization key',
  wei_xin_pu_tong_shang_hu: 'WeChat ordinary merchants',
  yi_chang_ming_cheng: 'Exception name',
  tai: '',
  wei_xin_zhi_fu: 'Wecvhat pay',
  dian_ji_zu_zhi_jia_gou_cha_kan_geng_duo_xin_xi: 'Click on the organizational structure for more information',
  dian: 'hour',
  yue_xiao_yue_kao_qian: 'The smaller, the more forward',
  zhang_qi: 'Account period',
  qing_shu_ru_cheng_yuan_shou_ji: `Please enter the member's mobile phone`,
  tui_kuan_cheng_gong: 'Refund successfully',
  chong_pao_qi_wei_an_zhuang_dao_wei: 'Brewer is not well fixed',
  la_qu_she_bei_yin_pin: 'Pull equipment drinks',
  jie_shu_shi_jian: 'End Time',
  ben_yue_xiao_shou_e: 'Monthly sales',
  deng_dai_xi_tong_wan_cheng_she_bei_yin_pin_du_qu: 'Wait for the system to finish reading device drinks',
  qing_shu_ru_dao_ru_she_bei_bian_hao: 'Please enter the import device number',
  ding_dan_fen_bu: 'Order distribution',
  suo_shu_fen_zu: 'Group Name',
  she_bei_can_shu_yi_ying_yong: 'Device parameters have been applied',
  bian_ji_cheng_yuan: 'Edit member',
  pei_zhi_zhi_fu_zhi_qian_qing_xian_zai_zhi_fu_bao_shang_hu_hou_tai_pei_zhi_zhi_fu_wang_ye_xin_xi: 'Before configuring payment, please configure payment webpage information in the Alipay merchant background',
  she_bei_bian_hao: 'device ID',
  xuan_qu_dao_chu_shu_ju: 'Choose export data',
  pei_fang_yin_pin_bu_yun_xu_xin_zeng: 'Recipe drinks are not allowed to be added',
  zhi_zuo_lei_xing: 'Production mode',
  zhi_zuo_zhuang_tai: 'Make status',
  zu_zhi_jia_gou: 'Organization',
  shang_yue: 'Last month',
  ben_yue_xiao_shou_ding_dan: 'Sales orders this month',
  chu_shi_zhuang_tai: 'Initial state',
  bian_ji_xin_xi: 'Edit information',
  bei_zhu: 'Remark',
  chan_pin_xing_hao: 'Product model',
  dian_re_pan_gong_shui_yi_chang: 'Thermo-Block Water Supply Error ',
  kai_shi_ri_qi: 'starting date',
  yu_shang_yue_dui_bi_bei_liang_qing_kuang: 'Compared with last month',
  she_bei_ji_fei_zhong_zhi_zhou_qi: 'Device charging reset cycle',
  dai_ji_ping_bao_bian_ji: 'Standby picture editing',
  ce_shi_ding_dan: 'Test order',
  xin_zeng_cheng_yuan: 'New member',
  jiao_se_mo_kuai: 'Role module',
  xuan_qu_yin_pin: 'Select a drink',
  cha_kan_xiang_qing: 'see details',
  qi_dong: 'Start LOGO',
  dui_bi_tong_ji: 'Comparative statistics',
  fen_zu_dui_bi: 'Group comparison',
  qing_xuan_ze_zhi_zuo_lei_xing: 'Please select a production type',
  guan_jian_zheng_ming_cheng: 'Key frame name',
  chong_pao_qi_qing_jie: 'Brewer deep clean',
  wei_hu_ming_cheng: 'Maintenance name',
  zhe_li_kong_kong_ru_ye: 'Her is blank',
  jiang_wen_jian_tuo_dao_ci_chu: 'Drag files here',
  qing_shu_ru_yin_pin_ming_cheng: 'Please enter the drink name',
  can_shu_shuo_ming: 'Parameter Description',
  ci_cao_zuo_jiang_tong_bu_yin_pin_zhi_she_bei: 'This operation will drink to the equipment, whether to continue?',
  shang_chuan_dai_ji_ping_bao: 'Upload standby picture',
  yi_tui_kuan: 'refunded',
  cha_kan_she_bei: 'View device',
  shi_fou_ji_xu_shan_chu: 'Continue to delete',
  she_bei_yin_pin_geng_xin: 'Device drinks update',
  qi_shi_shi_jian: 'Start time',
  ci_cao_zuo_jiang_hui_tui_hai_ding_dan_jin_e: 'This operation will refund the order amount',
  wu_xiao_zhi_fu: 'Invalid payment',
  shou_ji_jian_ce: 'Phone detection',
  mo_ren_wei_zhi_xian: 'The default is straight',
  qing_tian_xie_wan_zheng_xin_xi: 'Please fill in the complete information',
  ti_shi_wen_zi: 'Prompt text',
  she_bei_he_ji: 'Total equipment',
  rename_device: 'Rename pay name',
  wei_xin_nei_wu_fa_shi_yong_zhi_fu_bao_zhi_fu: 'Alipay cannot be used to pay in WeChat mode',
  jin_ri_ding_dan_shu: 'Orders today',
  yin_pin_can_shu_shang_chuan: 'Drink parameter upload',
  she_bei_yin_pin_tui_song_zhong: 'Push to device, please be patient',
  zhong_zhi_she_bei_fei_yong: 'Device replacement cost',
  qing_shu_ru_dui_ying_de_chan_pin: 'Please enter the corresponding product',
  qing_shu_ru_shou_ji_hao_ma: 'Please enter the phone number',
  pai_xu_wei_zhi: 'Sort position',
  bao_cun_pei_zhi: 'Save configuration',
  bao_cun_she_zhi: 'Save configuration',
  yi_bang_ding_she_bei: 'Bound device',
  shi_shi_she_bei_shu: 'Number of real-time devices',
  xuan_qu_dao_chu_shi_jian_duan: 'Choose export period',
  qing_shu_ru: 'Please input',
  shi_jian_wei_du: 'Time dimension',
  chong_zhu_xi_tong_yi_chang: 'Brewer Error',
  jin_ri_xiao_shou_e: `today's sales`,
  xin_zeng_fen_zu: 'New group',
  shan_chu_fen_zu: 'Delete group',
  xiang_guan_she_bei: 'relative devices',
  zhi_zuo_guo_cheng_zhan_shi_tu: 'Production process display map',
  pei_zhi_zhi_fu_zhi_qian_qing_xian_zai_wei_xin_shang_hu_hou_tai_pei_zhi_zhi_fu_wang_ye_xin_xi: 'Before configuring payment, please configure payment webpage information in WeChat merchant background',
  qing_xuan_qu_xu_yao_dao_chu_de_shu_ju: 'Please select the data to be exported',
  zhi_zuo_qing_dan: 'Making list',
  xiao_bei: 'Small Cup',
  mo_dou_ji_yi_chang: 'Grinder Error',
  shang_chuan_hou_li_ji_xiu_gai_shi_pin: 'Edit video immediately after upload',
  ke_xuan_wei: 'Optional',
  jie_shu_ri_qi: 'end date',
  dian_ji_cha_kan_geng_duo_shuo_ming: 'Click for more instructions',
  qing_dao_ru_shou_quan_zheng_shu: 'Please import authorization certificate',
  shan_chu: 'delete',
  guan_bi_quan_xian: 'close right',
  yi_guan_bi_quan_xian: 'has close right',
  wei_guan_bi_quan_xian: 'not close right',
  yue: 'month',
  da_bei: 'big cup',
  chuang_jian_cheng_gong: 'Created successfully',
  ben_zhou_xiao_shou_e: 'Sales this week',
  dang_qian_gong_neng_zan_wei_kai_fang: 'Function not available',
  ji_shu_zhu_li_shang_ye_fa_zhan: 'Technology boosts business development',
  ci_cao_zuo_jiang_shan_chu_yin_pin_pei_fang: 'This action will delete the drink recipe',
  she_bei_shu: 'device no.',
  xuan_qu_xu_yao_tong_bu_she_bei_hou: 'Choose a synchronous device, click synchronization',
  fen_ge: 'Separate',
  zhi_fu_bao_pu_tong_shang_hu: 'Alipay ordinary merchants',
  yi_bang_ding_jiao_se_yong_hu: 'Role users',
  bao_yang_fen_xi: 'Maintenance analysis',
  she_bei_yin_pin: 'Equipment drinks',
  qing_xuan_qu_xu_yao_dao_chu_de_fen_zu_huo_she_bei: 'Please select the group or device to be exported',
  zui_jin_yi_ci_zhong_zhi_shi_jian: 'Lastest reset time',
  wen_du_guo_gao: 'temperature over heating',
  yi_chang: 'error',
  wang_ji_mi_ma: 'forget password',
  dan_wei_wei_yuan: 'Unit is RMB, support two decimal places',
  ci_cao_zuo_jiang_quan_liang_la_qu_she_bei_yin_pin_zhi_yun_duan: 'This operation will pull equipment of all drink to the cloud, whether or not to continue',
  zhang_qi_shi_jian: 'Account period',
  tou_xiang: 'head portrait',
  bing_xiang_tong_xin_yi_chang: 'Fridge Communication Error',
  she_bei_zhi_zuo_bei_shu: 'Total cups',
  zhi: 'to',
  tong_xin_yi_chang: 'Communication Error',
  yin_pin_zhi_zuo_bei_shu: 'drinks making cups',
  ding_dan_tui_kuan: 'Order refund',
  dai_wei_xiu: 'To be repaired',
  suo_you_fen_zu: 'All groups',
  yun_ying_shu_ju: 'Operational data',
  yi_chang_ci_shu_zong_ji: 'Total number of error',
  bian_ji: 'edite',
  qing_shu_ru_shang_chuan_she_bei_bian_hao: 'Please enter upload device number',
  wei_hu_she_zhi: 'Maintenance settings',
  jiao_ban_qi_qing_xi: 'mixer rinse',
  tui_kuan_zhuang_tai: 'Refund status',
  jiao_yi_shou_xu_fei_you_wei_xin_shou_qu: 'Transaction fees are charged by WeChat',
  wang_ye_quan_ping: 'Full screen',
  ru_guo_shi_quan_ping: 'If it is full screen',
  dong_hua_bo_fang_de_ci_shu: 'Animation plays',
  xin_zeng_cao_zuo_shuo_ming: 'New operating instructions',
  jiao_yi_shou_xu_fei_you_zhi_fu_bao_shou_qu: 'Transaction fees are charged by Alipay',
  xuan_qu_suo_xu_dao_chu_fen_zu: 'Select the desired export group',
  shi_jian_qu_jian: 'Time interval',
  zui_jin_san_ge_yue: 'The last three months',
  qing_xuan_ze_suo_shu_fen_zu: 'Please select the group',
  cheng_yuan_fen_zu: 'Member group',
  xia_yi_bu: 'next step',
  xin_xi_geng_xin: 'information upgrading',
  zhi_fu_bao: 'Ali pay',
  zhi_fu_bao_nei_wu_fa_shi_yong_wei_xin_zhi_fu: 'WeChat payment cannot be used in Alipay',
  xin_zeng_cheng_gong: 'added successfully',
  ben_zhou_xiao_shou_ding_dan: 'Sales orders this week',
  she_bei_zhou_qi_fei_yong_shang_xian: 'Maximum equipment cycle cost',
  qing_shu_ru_yin_pin_ying_wen_ming_cheng: 'Please enter the English name of the drink',
  ding_dan_zhuang_tai: 'Order Status',
  zi_jin_jie_suan_zhi_zhi_fu_bao_shang_hu: 'Settlement of funds to Alipay merchants',
  huo: 'or',
  fei_yong_zhang_dan: 'Expense bill',
  ci_cao_zuo_jiang_yi_chu_cheng_yuan: 'This action will remove the members, whether to continue?',
  shang_hu: 'Merchant',
  chong_zhu_xi_tong_qing_xi: 'Brewer rinse',
  yi_chang_fen_xi: 'Anomaly analysis',
  gao_jing_ming_cheng: 'warning name',
  ci_cao_zuo_jiang_shan_chu_she_bei_zhi_zuo_tu_pian: 'This action will delete the device to make pictures',
  zhi_zuo_zhong: 'on process',
  ci_cao_zuo_jiang_yi_chu_she_bei_yu_bu_men_guan_xi: 'This action will remove the equipment and the relationship between departments, whether or not to continue',
  qing_que_bao_xuan_qu_she_bei_zai_xian: 'Please make sure the selected device is online',
  can_shu_pei_zhi: 'Parameter configuration',
  nian: 'year',
  zhi_zuo_guo_cheng_shi_pin: 'video plays on making process',
  qing_dao_ru_shou_quan_mi_yao: 'Please import the authorization key',
  qing_shu_ru_shang_hu_mi_yao: 'Please enter the merchant key',
  zhi_zuo_fang_shi_fen_bu: 'Production method distribution',
  zhu_ce_shi_jian: 'Registration time',
  qu_xiao: 'cancel',
  zhi_zuo_shi_pin_bian_ji: 'Make video editor',
  qing_shu_ru_she_bei_bian_ma: 'Please enter the device code',
  she_bei_bao_yang_fen_bu: 'Equipment maintenance distribution',
  mo_ren_hui_fan_hui: 'return by default',
  xiao_bei_jia_ge: 'Small cup price',
  xiang_guan_mo_kuai: 'Related modules',
  qing_lian_xi_guan_li_yuan_kai_tong_quan_xian: 'Please contact the administrator for permission',
  yi_chang_ming_xi: 'Exception details',
  xiu_gai_yin_pin_ke_tong_guo_pi_liang_ding_jia_chu_jin_xing_xiu_gai: 'Modified drinks can be modified through the bulk pricing office',
  she_bei_bang_ding_cheng_gong: 'Device binding successful',
  loading_success: 'information loading successful',
  guan_bi: 'close',
  fan_hui: 'return',
  dao_ru_cheng_gong: 'Import succeeded',
  gong_zhong_hao: 'public accounts',
  qing_shu_ru_shang_hu: 'Please enter the merchant',
  fei_zhi_fu_ding_dan: 'Non-payment order',
  qing_xuan_qu_jie_shu_gong_zuo_shi_jian: 'Please select end time',
  bian_ji_ping_bao: 'Edit screensaver',
  shou_quan_gong_yao: 'Authorized public key',
  shan_chu_jiao_se_jiang_dao_zhi_yong_hu_wu_fa_zheng_chang_shi_yong_xi_tong_gong_neng: 'Deleting a role will cause users to fail to use system functions',
  she_bei_ming_cheng: 'Device name',
  xin_zeng_yin_pin_pei_fang: 'New beverage recipe',
  bian_ji_cheng_gong: 'Edit successfully',
  shou_quan_mi_yao: 'Authorization key',
  cao_zuo: 'operation',
  wei_hu_shu_ju: 'Maintain data',
  tian: 'day',
  fen_pei_she_bei: 'Distribution equipment',
  ping_bao_tu_pian_zui_shao_yi_zhang: 'At least one screensaver picture',
  ben_yue_ding_dan_shu: 'Orders this month',
  zhi_fu_fang_shi_fen_bu: 'Payment method distribution',
  zheng_zai_huo_qu_she_bei_yin_pin: 'Is access to equipment, please be patient',
  ci_cao_zuo_jiang_shan_chu_she_bei: 'This action will delete the device',
  bang_ding_shi_jian: 'Binding time',
  ben_zhou_ding_dan_shu: 'Orders this week',
  yi_xuan_fen_zu: 'Selected group',
  yin_pin_shu_ju: 'Drinks data',
  bang_ding_she_bei: 'Binding device',
  shang_hu_hao: 'business number',
  re_shui_guo_lu_gong_shui_yi_chang: 'HotWater Boiler Water Supply Error',
  yin_pin_bang_dan: 'Drinks list',
  zui_jin_yi_ge_yue: 'Last month',
  ji_fei_shi_jian: 'Billing time',
  shang_chuan_hou_li_ji_xiu_gai: 'Modify immediately after upload',
  xuan_qu_ri_qi: 'Select date',
  qing_shu_ru_shou_quan_gong_yao: 'Please enter the authorized public key',
  shi_xu_yao_bang_ding_dao_xuan_ze_qi_de_guan_jian_zheng_ming_cheng: 'The keyframe name that needs to be bound to the selector',
  qing_shu_ru_fen_zu_ming_cheng: 'Please enter a group name',
  qing_shu_ru_guan_bi_quan_xian_ming_cheng: 'Please input right name',
  zheng_qi_dian_re_pan: 'steam thermo-block',
  ding_dan_gai_kuang: 'Order overview',
  zhi_fu_jin_e: 'Payment amount',
  qing_tian_ru_shou_quan_gong_yao: 'Please fill in the authorized public key',
  qing_xuan_qu_xu_yao_tui_song_de_she_bei: 'Please select the device to be pushed',
  she_bei_xin_xi: 'Device Information',
  yin_pin_lie_biao: 'beverage list',
  geng_duo_pei_zhi: 'more setting',
  xiu_gai_cheng_gong: 'Successfully modified',
  dang_tian: 'today',
  zhi_fu_ding_dan: 'Payment order',
  all: 'all',
  make_success: 'make success',
  make_fail: 'make fail',
  shang_chuan_shi_bai: 'upload failed',
  shi_fou_ji_xu: 'to continue',
  shi_jian_fan_wei: 'time range',
  zui_jin_yi_nian: 'last one year',
  yi_zhi_fu: 'paid',
  xin_zeng_jiao_se: 'creat new member',
  suo_shu_chan_pin: 'product',
  dai_wei_hu: 'To be maintained',
  bao_cun_ping_bao: 'Save screensaver',
  yin_pin_xin_xi_yi_xia_fa: 'Drink information has been issued',
  zui_xiao_de_shan_qu_jiao_du: 'Minimum sector angle',
  de_li_wei_zhi: 'Geographic location',
  zhuang_tai: 'statue',
  tian_jia_cheng_gong: 'Added successfully',
  an_quan_tui_chu: 'Retreat safely',
  shang_yi_bu: 'Previous step',
  suo_you_zhi_fu: 'All payments',
  zhi_zuo_shi_bai: 'Production failed',
  xuan_qu_gong_si: 'Select company',
  wei_hu_xin_xi_bian_ji: 'Maintenance information editing',
  gong_zuo_shi_jian: 'operating hours',
  mo_dou_xiao_yan: 'grinder calibration',
  mi_ma_deng_lu: 'Password login',
  sheng_yu_fei_yong_e_du: 'Remaining expenses',
  jin_san_shi_tian_cheng_jiao: 'Deals in the last 30 days',
  dong_hua_de_su_du_qu_xian: 'Animation speed curve',
  yi_chang_gao_jing: 'Abnormal alarm',
  shi_xian_shui_ping_ju_zhong: 'Achieve horizontal centering',
  deng_lu_mi_ma: 'login password',
  bang_ding_cheng_yuan: 'Binding member',
  yi_chang_zhan_bi: 'Abnormal proportion',
  fen_liao_he_wei_an_zhuang_dao_wei: 'powder hopper not well fixed',
  da_bei_jia_ge: 'large cup price',
  xin_zeng_she_bei: 'creat device',
  jiao_se_ming_cheng: 'memebr name',
  bian_ji_yin_pin: 'edite beverage ',
  yi_chu_cheng_gong: 'Successfully removed',
  jie_zhi_jin_ri: 'until today',
  ti_shi: 'tips',
  edit_department_name: 'please input department name',
  qing_xuan_ze_she_bei_zhuang_tai: 'Please select device status',
  ren_wu_bian_hao: 'Task number',
  ri: 'day',
  yi_chang_lei_xing: 'Exception type',
  zi_ding_yi_xin_zeng: 'customize adding',
  dai_ji_ping_bao: 'stand by screensaver',
  li_xian: 'off-line',
  zhong_zhi_e_du_zhou_qi: 'Reset credit cycle',
  wu_zhi_fu_ding_dan: 'No payment order',
  jiao_se_xin_xi: 'member information',
  xi_tong_ya_li_guo_da: 'Pressure Overloaded',
  ke_tong_guo_ye_mian_jin_xing_tian_jia_cao_zuo: 'Can be added through the page',
  zhong_bei: 'medium cup',
  qing_shu_ru_zhi_fu_ming_cheng: 'Please enter the payment name',
  shu_ju_dao_chu: 'data export',
  zhi_zuo_tu_pian_bian_ji: 'Making picture edite',
  xiao_shou_e: 'turnover',
  wu_zhi_fu: 'No payment',
  qing_shu_ru_yuan_gong_ming_cheng: 'Please enter the employee name or phone number',
  zheng_chang_yun_xing: 'normal operation',
  qing_shu_ru_deng_lu_mi_ma: 'Please enter your password',
  qing_shu_ru_yan_zheng_ma: 'Please input cat',
  qing_shu_ru_wei_hu_ming_cheng: 'Please enter a maintenance name',
  xian_zhi_fen_bian_lv_can_kao_ji_xing_fen_bian_lv_shou_ce: 'Refer to the model resolution manual for limited resolution',
  quan_bu_mo_kuai: 'All modules',
  huo_qu_qi_ye_bian_hao: 'Get the company number',
  yong_hu_ming_cheng: 'user name',
  ti_jiao: 'submit',
  ding_dan_fen_xi: 'Order analysis',
  jin_ru_ping_tai: 'Enter platform',
  yong_hu_shou_ji_hao: 'User phone number',
  que_ding: 'confirm',
  fei_yong_pei_zhi: 'Cost allocation',
  qing_shu_ru_zhi_fu_gong_zhong_hao: 'Please enter the payment account',
  zhong_zhi_cheng_gong: 'Reset successfully',
  qie_huan_zhang_qi: 'Switch account period',
  dan_tai_she_bei_ping_jun_zhi_zuo_bei_shu: 'Average number of cups made by a single device',
  zhi_fu_fang_shi: 'payment method',
  she_bei_lie_biao: 'device list',
  dian_ji_tong_bu_ji_ke: 'Click sync',
  dong_hua_suo_hua_fei_de_shi_jian: 'Time spent on animation',
  fen_liao_xiao_yan: 'powder calibration',
  dan_wei: 'unit',
  yi_chang_shi_jian: 'Abnormal time',
  xuan_qu_pei_fang_zhong_bao_han_de_yin_pin: 'Select the drinks included in the recipe',
  qing_xuan_qu_kai_shi_gong_zuo_shi_jian: 'Please select a working time',
  re_shui_guo_lu_jia_re_chao_shi: 'HotWater Boiler Heating Overtime',
  ci_cao_zuo_jiang_yi_chu_cheng_yuan_yu_bu_men_guan_xi: 'This action will remove the member-department relationship',
  duo_ge_bian_hao_yong_ying_wen_dou_hao: 'Multiple numbers with commas',
  cheng_yuan_lie_biao: 'member list',
  mo_ren_jiao_se: 'Default role',
  qing_shu_ru_jiao_se_ming_cheng: 'Please enter a role name',
  she_bei_bang_dan: 'Equipment list',
  jin_tian: 'today',
  yin_pin_xin_xi: 'beverage infromation',
  qing_xuan_qu_she_bei: 'Please select a device',
  zuo_biao_zhou_zhi_shi_qi: 'Coordinate axis indicator',
  qing_xian_xuan_qu_ping_bao_tu_pian: 'Please select a screensaver picture first',
  fen_pei_cheng_gong: 'Assigned successfully',
  re_shui_guo_li: 'hot water boiler',
  shang_chuan_cheng_gong: 'Uploaded successfully',
  cha_kan_cheng_yuan: 'View members',
  huan_ying_nin: 'welcome you',
  bao_cun: 'save',
  qing_xuan_qu_fu_zhi_she_bei: 'Please select a copy device',
  zi_jin_jie_suan_zhi_wei_xin_shang_hu: 'Settlement of funds to WeChat merchants',
  jin_ri_xiao_shou_ding_dan: `Today's sales order`,
  ci_cao_zuo_jiang_shan_chu_she_bei_zhi_zuo_shi_pin: 'This action will delete the device to make the video',
  ben_yue: 'this month ',
  pai_xu: 'Sort',
  ting_ji_she_bei_shu: 'Number of down equipment',
  qing_wan_shan_she_bei_ming_cheng: 'Please complete the device name',
  bei_liang: 'capacity',
  qing_shu_ru_shang_hu_hao: 'Please enter the merchant number',
  jiao_se_pei_zhi: 'Role configuration',
  zhi_fu_bao_zhi_fu: 'Ali pay',
  xuan_qu_dao_chu_she_bei: 'select export device',
  bao_yang_ming_xi: 'Maintenance details',
  yin_pin_ming_cheng: 'beverage name',
  dan_tai_she_bei_ping_jun_cheng_jiao_e: 'Average turnover of a single device',
  zhi_fu_she_zhi: 'Payment settings',
  she_zhi_cheng_gong: 'Set up successfully',
  zuo_tian: 'yesterday',
  qing_shu_ru_she_bei_ming_cheng: 'Please input the device name/IEMI',
  she_bei_chu_shi_hua: 'Device initialization',
  niu_nai_xi_tong_qing_xi: 'milk system rapid rinse',
  shan_chu_cheng_gong: 'successfully deleted',
  zhi_zuo_bei_shu: 'Making cups',
  qing_xuan_qu_dao_chu_shi_jian: 'Please select an export time',
  tiao_jian_sou_suo: 'Conditional search',
  qing_nai_xin_deng_dai: 'please wait patiently',
  xuan_qu_she_bei: 'Choose device',
  chong_pao_qi_zi_jian: 'Brewer Check up',
  shi: 'hour',
  bian_ma_sou_suo: 'Code search',
  shan_chu_zhi_fu: 'Delete Pay Config',
  zan_wei_she_zhi_de_li_wei_zhi: 'No location set yet',
  ce_shi_she_bei: 'testing device',
  ji_fei_xiang_dan: 'Billing details',
  ci_cao_zuo_jiang_shan_chu_she_bei_ping_bao: 'This action will delete the device screensaver',
  suo_you_she_bei: 'all device',
  qing_xuan_qu_xu_yao_fen_pei_de_cheng_yuan: 'Please select the members to be assigned',
  qing_shu_ru_bu_men_ming_cheng: 'Please enter the department name',
  qing_shu_ru_gong_zhong_hao: 'Please enter the public account',
  ka_fei_dian_re_pan_jia_re_chao_shi: 'Coffee thermo-block Heating Overtime',
  rang_fu_wu_duan_fan_hui: 'Let the server return',
  yin_pin_zhi_zuo_lie_biao: 'Drink making list',
  ji_fei_she_bei_shu: 'Billing equipment',
  ping_xian_guan_li: 'On-screen display management',
  dao_chu_shu_ju: 'export data',
  xuan_qu_fen_zu: 'Select Group',
  fen_xiang_fa_zi_jian: 'Diverted Valve Check Up',
  zhong_bei_jia_ge: 'medium cup price',
  geng_xin_cheng_gong: 'update completed',
  ji_fei_shu: 'Billing number',
  nin_de_liu_lan_qi_zan_shi_bu_zhi_chi_shi_pin: 'Your browser does not support video temporarily',
  qing_shu_ru_cheng_yuan_deng_lu_mi_ma: 'Please enter the member login password',
  huan_jing_wen_du_guo_di: 'Environment Temp. Is Too Low',
  chan_pin_ming_cheng: 'Beverage name',
  yin_pin_bian_hao: 'beverage ID',
  fu_zhi_yin_pin: 'copy beverage',
  xun_huan_zhong_zhi_ji_fei_zhou_qi: 'Cycle reset billing cycle',
  cheng_jiao_e: 'Turnover',
  ding_dan_shi_jian: 'Order time',
  qing_shu_ru_cheng_yuan_ming_cheng: 'Please enter member name',
  cheng_gong: 'success',
  shou_ji_hao: 'phone no.',
  qing_shu_ru_yuan_gong_deng_lu_mi_ma: 'Please enter the employee login password',
  xi_tong_que_shui: 'system lack of water',
  bei: 'cup',
  cheng_yuan_xin_xi: 'Member Information',
  yin_pin_pei_fang: 'Drink recipe',
  cheng_yuan_ming_cheng: 'Member name',
  ding_yi_guan_jian_zheng: 'Define keyframes',
  zheng_qi_dian_re_pan_jia_re_chao_shi: 'Steam thermo-block Heating Overtime',
  she_bei_wei_zhi: 'device position',
  qing_xi_bei_shu: 'Rinse total cups',
  qing_xuan_qu_xu_yao_fen_pei_de_she_bei: 'Please select the device to be assigned',
  zhi_chi_xiao_shu_dian_hou_liang_wei: 'Support two decimal places',
  suo_you_ding_dan: 'all orders',
  zheng_dian_shi_shi_ding_dan: 'Hourly real-time order',
  ka_fei_dian_re_pan: 'coffee thermo-block',
  yi_xuan_yin_pin: 'selected drinks',
  qing_shu_ru_shang_chuan_yin_pin_bian_hao: 'Please enter the upload beverage number',
  shou_ji: 'phone',
  lei_ji_ding_dan_jin_e: 'Total order amount',
  huan_bi_zeng_zhang: 'MoM growth',
  wu_jia_yun_ke_ji_ti_gong_ji_shu_zhi_chi: '五加云科技提供技术支持',
  qie_huan_gong_si: 'Switch companies',
  ru_guo_bu_jin_xing_tui_kuan_ze_bu_xu_yao: 'If you do not make a refund, you do not need',
  chan_pin: 'product',
  yi_chang_shu_ju: 'abnormal data',
  ji_xing_fen_bian_lv_shou_ce: 'Model Resolution Manual',
  kai_shi_fen_xi: 'Start analysis',
  shou_quan_zheng_shu: 'Certificate of Authorization',
  li_xian_she_bei: 'Offline device',
  dian_ji_shang_chuan: 'Click to upload',
  yuan: 'Yuan',
  qing_xian_shang_chuan_yin_pin_tu_pian: 'Please upload a beverage picture first',
  fen_zu_ming_cheng: 'Group Name',
  kai_shi_wei_yuan_shi_da_xiao: 'Start at original size',
  yi_chu_pei_fang_zhong_yin_pin_xin_xi_bu_hui_ying_xiang_yuan_shi_pei_fang_shu_ju: 'Removal of beverage information in the recipe will not affect the original recipe data',
  qing_shu_ru_tui_kuan_mi_yao: 'Please enter the refund key',
  lei_ji_ding_dan_shu: 'Total orders',
  fen_xiang_fa_yi_chang: 'Diverted Valve Error',
  chu_gou: 'Descaling',
  tong_bu_cheng_gong: 'Synchronized successfully',
  zhi_fu_ming_cheng: 'Payment name',
  she_bei_zhou_qi_ji_fei_shang_xian: 'Device cycle billing limit',
  fen: 'minutes',
  dou_he_wei_an_zhuang_dao_wei: 'Bean hopper not well fixed',
  yin_pin_ying_wen_ming_cheng: 'English name of drink',
  qing_kai_shi_she_zhi_xu_yao_shang_chuan_de_yin_pin: 'Please start to set the drinks that need to be uploaded',
  xin_zeng_wei_hu_she_zhi: 'New maintenance settings',
  qu_xiao_bang_ding: 'Unbind',
  tian_ru_pei_fang_ming_cheng: 'Fill in the formula name',
  xin_zeng_fen_xi_zu: 'New analysis group',
  cheng_jiao_jin_e: 'Turnover',
  jin_e: 'money',
  jie_bang: 'unbind',
  fen_pei_shi_jian: 'Allocate time',
  she_bei_zhuang_tai: 'equipment status',
  wei_jian_ce_dao_gai_zhang_hu_bang_ding_qi_ye: 'The account binding enterprise is not detected',
  xuan_qu_zai_xian_she_bei: 'Select online device',
  qing_tian_xie_dui_ying_xin_xi: 'Please fill in the corresponding information',
  qing_xuan_qu_xu_yao_dui_bi_de_fen_zu: 'Please select the group to compare',
  qing_xuan_qu_she_bei_huo_fen_zu: 'Please select a device or group',
  qing_shu_ru_she_bei_bian_hao: 'Please enter the device ID number',
  wei_bang_ding_jiao_se_yong_hu: 'Unbound role users',
  pin_ming_jia_zai_zhong: 'loading',
  geng_duo_she_zhi: 'more settings',
  yin_pin_pei_zhi: 'Drink setting',
  she_bei_lie_biao_zhong_de_yin_pin_xin_xi_ke_jin_xing_dan_ge_yin_pin_xin_xi_xiu_gai: 'The beverage information in the device list can be modified for individual beverage',
  qing_xuan_ze_zhi_fu_fang_shi: 'Please select mode of payment',
  qing_xuan_qu_xu_yao_pei_zhi_quan_xian: 'Please select the need to configure permissions',
  she_bei_yi_chang_zeng_zhang_lv_fen_bu: 'Equipment abnormal growth rate distribution',
  chuang_jian: 'create',
  zui_jin_yi_zhou: 'Last week',
  jia_zai_she_bei: 'Loading device',
  ben_ji_cheng_yuan: 'Members of this level',
  bu_ke_cao_zuo: 'Do not operate',
  ding_dan_bian_hao: 'Order Number',
  order_number: 'Order Number',
  pay_number: 'pay number',
  zhi_zuo_shi_jian: 'Produce Time',
  yin_pin_ming_chen: 'Drink Name',
  yin_pin_bei_liang: 'Cup',
  zui_jin_yi_yue: 'In recent month',
  zui_jin_san_yue: 'Recently in March',
  qing_shu_ru_ding_dan_bian_hao: 'Please input the order number',
  dui_bi_fen_xi: 'Comparison and analysis',
  fen_zu_ming_chen: 'Group Name',
  qing_shu_ru_fen_zu_ming_chen: 'Please input group name',
  qing_shu_ru_she_bei_ming_chen: 'Please input  device name',
  di_li_wei_zhi: 'GEO Position',
  geng_xin_she_bei_wei_zhi: 'Update Device GEO',
  xuan_qu_di_li_wei_zhi: 'choice GEO',
  chan_pin_ming_chen: 'Product Name',
  she_bei_ming_chen: 'Device Name',
  she_bei_suo_ding: 'Device Lock',
  pei_fang_ming_cheng: 'Recipe name',
  tong_bu_yin_ping_pei_fang: 'Synchronous drink formula',
  shan_chu_pei_fang: 'Remove the formula',
  yi_chu: 'Remove',
  xin_zeng_tong_bu_she_bei: 'Add Synchronous Device',
  zai_xian_she_bei_lie_biao: 'Online device list',
  guan_lian_she_bei: 'Bind Device',
  tong_bu_cao_zuo_shuo_ming: 'Synchronization instructions',
  qing_shu_ru_pei_fang_ming: 'Please enter the recipe name',
  fa_sheng_shi_jian: 'Happen At',
  hui_fu_zheng_chang: 'Recovery',
  fa_sheng_yi_chang: 'Fault',
  xuan_qu_device: 'Choice export device',
  quan_xuan: 'all',
  logo_bian_ji: 'LOGO Edit',
  tip_logo: 'Limited reference model resolution manual, modify LOGO immediately after upload',
  drag_file: 'drag file to here，or click',
  add_ali_pay: 'Config Ali Pay',
  add_wx_pay: 'Config Wechat Pay',
  reload_pay: 'Reload Pay information',
  wechat_pay_tip: 'Capital settlement to WeChat merchants, by WeChat collection poundage(Ali pay is unusable in wechat pay)',
  wechat_pay_tip_remark: '(Ali pay is unusable in wechat pay)',
  ali_pay_tip: 'Capital settlement to Ali merchants, by Ali collection poundage(Wechat pay is unusable in Ali pay)',
  ali_pay_tip_remark: '(Wechat pay is unusable in Ali pay)',
  remark_wechat_config: 'Configuration before payment please contact your system administrator',
  t_500865ef2001000: 'Home',
  t_50083b154801000: '研发管理',
  t_50084945b801000: '设备管理',
  t_50084a5d9401000: 'Home',
  t_50084b33a001000: 'System Set',
  t_50085d8eb001000: 'Home',
  t_500867b84801000: 'Member',
  t_50086895bc01000: 'Order',
  t_500869810c01000: 'Device',
  t_50086a34e001000: 'System',
  t_50088bc26001000: 'System',
  t_50086cbb4c01000: 'Organization',
  t_50086f4e0001000: 'Member',
  t_50087496d401000: 'Order Analysis',
  t_500876e1a401000: 'Order List',
  t_50087b146c01000: 'Device List',
  t_50087d152001000: 'Screen Manager',
  t_50087ea47001000: 'Drink Manger',
  t_500880105001000: 'Matainset',
  t_5008847d6c01000: 'Fee',
  t_500885da1401000: 'Data Analysis',
  t_50088a319801000: 'Pay Config',
  t_5008f30d3401000: 'Role Config',
  t_55be408fd001000: 'Alarm List',
  t_55d2b4167c01000: 'Fault Alarm',
  t_563a1a536801000: 'Data Export',
  t_500985da1401000: 'Compare Analysis',
  t_500841ad6401000: 'Exception',
  t_500843637c01000: 'Version',
  t_5008453b5001000: 'Product',
  t_500850925401000: 'Devices',
  t_50085288b001000: 'Enterprises',
  t_5523bc9d8001000: 'Drip Tray Is Not In Place',
  t_5523bca5f401000: 'Grounds Container Is Full Up',
  t_5523bcae6401000: 'Water Tank Is Empty',
  t_5523bcb74001000: 'Drip Tray Is Full Up',
  t_5523bcbfb401000: 'Water Barrel Empty',
  t_5523bcc85801000: 'Wastewater Tank Full up',
  t_5523bcd0c001000: 'Brewer Unfixed',
  t_5523bcd97c01000: 'Door Unclosed',
  t_5523bce1f401000: 'Bean Hopper Unfixed',
  t_5523bcea5801000: 'Bean Hopper Unfixed',
  t_5523bcf33001000: 'Bean Hopper Unfixed',
  t_5523bcfbec01000: 'Bean Hopper Empty',
  t_5523bd04c801000: 'Bean Hopper Empty',
  t_5523bd0d6801000: 'Bean Hopper Empty',
  t_5523bd160001000: 'Powder Hopper Unfixed',
  t_5523bd1ed801000: 'Powder Hopper Unfixed',
  t_5523bd277001000: 'Powder Hopper Unfixed',
  t_5523bd301001000: 'Powder Hopper Empty',
  t_5523bd38c401000: 'Powder Hopper Empty',
  t_5523bd416401000: 'Powder Hopper Empty',
  t_5523bd4a2401000: 'Grinder Calibration',
  t_5523bd52e401000: 'Descaling Required',
  t_5523bd5b9001000: 'Brewing Unit Deep Clean Required',
  t_5523bd645801000: 'Brewer Washing Required',
  t_5523bd6d0001000: 'Milk Frother Deep Clean Required',
  t_5523bd75b401000: 'Power Hopper Clean Required',
  t_5523bd7e6001000: 'Milk Low Temperature',
  t_5523bd86f801000: 'Milk High Temperature',
  t_5523bd8fc001000: 'Milk Box Is Empty',
  t_5523bd9d5c01000: 'Milk Box Unfixed',
  t_5523bda5f401000: 'System Lacks of Water',
  t_5523bdaee401000: 'Pressure Overloaded',
  t_5523bdb79401000: 'Brewer Check up',
  t_5523bdc5f801000: 'Diverted Valve Check Up',
  t_5523bdd00401000: 'Temperature Overheated',
  t_5523bdd8f801000: 'Environment Temp. Is Too Low',
  t_5523bde1ac01000: 'Coffee Boiler Overheated',
  t_5523bdeab801000: 'Steam Boiler Overheated',
  t_5523bdf37801000: 'Hotwater Boiler Overheated',
  t_5523bdfc1801000: 'Coffee Boiler Temp. Is Too Low',
  t_5523be04d801000: 'Steam Boiler Temp. Is Too Low',
  t_5523be0da001000: 'HotWater Boiler Temp. Is Too Low',
  t_5523be164801000: 'System Water Filling Overtime',
  t_5523be1ee401000: 'HMI Communication Error',
  t_5523be277c01000: 'Coffee Boiler Heating Overtime',
  t_5523be304401000: 'Steam Boiler Heating Overtime',
  t_5523be392001000: 'HotWater Boiler Heating Overtime',
  t_5523be41dc01000: 'Coffee Boiler NTC Error',
  t_5523be4abc01000: 'Steam Boiler NTC Error',
  t_5523be536c01000: 'HotWater Boiler NTC Error',
  t_5523be5c1801000: 'Coffee Boiler Water Supply Error',
  t_5523be64b401000: 'Steam Boiler Water Supply Error',
  t_5523be6d6001000: 'HotWater Boiler Water Supply Error',
  t_5523be760c01000: 'Brewer Error',
  t_5523be7efc01000: 'Diverted Valve Error',
  t_5523be880c01000: 'Grinder Error',
  t_5523be95f001000: 'Left Grinder Error',
  t_5523be9eac01000: 'Right Grinder Error',
  t_5523beac5801000: 'Fridge Communication Error',
  t_512885da1401000:'Material analysis',
  language: 'English',
  forget_password_tip: 'Forget your password, please contact your administrator',
  unbind_enterprise: 'Phone unbind',
  complete_info: 'Fill All Info',
  TB_tip: 'Technical support business development',
  login_entry: 'Manage the login',
  huan_ying_shi_yong: 'Welcome to you',
  shi_fou_jie_bang_she_bei: 'Disconnect device pay?',
  a_group: 'A Group',
  b_group: 'B Group',
  company_number: 'Company Number',
  safe_quit: 'Safe Quit',
  welcome_to_you: 'Welcome',
  empty_info: 'Here is empty, can add the operation through the pages',
  fill_payment_name: 'Please fill in payment name after click below',
  createAuthorizedQrCode: 'Create authorized qr code',
  produceAuthorizedQrCode: 'Produce authorized qr code',
  payAuth: 'Payment authorization',
  lookPayProgress: 'look pay progress',
  status: 'apply status',
  applying: 'applying',
  fail: 'fail',
  success: 'successful',
  wechatScanSureAuth: 'Please use the super administrator WeChat scanning, complete signed confirmation',
  applyFail: 'apply fail',
  delete_pay_info:'will delete paying info，continue?',
  su_zhou_nong_hang:'su zhou abChina bank',
  queryAliStatus:'query ali-auth code',
  delete_device_alarm_info: 'Deleting a device will makes the device history data invisible, is continue?',
  wu_liao_fen_xi:'Material analysis',
  ka_fei_dou_shu:'Coffee beans weigh per gram',
  ke:'Gram',
  nai_mo_liang:'Milk foam quantity',
  hao_sheng:'Milliliters',
  nai_gai_liang:'Milk capping quantity',
  jin_30_tian_wu_liao_xiao_hao:'Material consumption in recent 30 days',
  niu_nai_liang:'Milk quantity',
  shu_liang:'Quantity',
  dao_chu:'Export',
  fen_liao_ke_zhong:'Powder weight',
  tong_bu_she_bei_yin_pin_pei_fang:'Synchronous equipment beverage formula',
  yin_pin_xin_xi:'Beverage information',
  xiao_bei_jia_ge_yuan:'Small cup price (yuan)',
  zhong_bei_jia_ge_yuan:'Medium cup price (yuan)',
  da_bei_jia_ge_yuan:'Large cup price (yuan)',
  pai_xu_yue_xiao_yue_kao_qian:'Sort (the smaller, the higher)',
  ci_cao_zuo_jiang_quan_liang_la_qu_she_bei_yin_pin_pei_fang_zhi_yun_duan:'This operation will pull the full amount of equipment beverage formula to the cloud, do you want to continue?',
  geng_xin_shi_jian:'Update time',


}
